import React, { useState } from 'react';
import { Search, Filter, BarChart3, List } from 'lucide-react';
import './App.css';

import SpotifyAuth from './SpotifyAuth';
import AnalyticsView from './AnalyticsView';
import { getAddedByLabel } from './spotifyUsers';

const SpotifyCollaborator = () => {
  const [activePlaylist, setActivePlaylist] = useState({
    label: 'All Songs',
    id: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortBy, setSortBy] = useState('dateAdded');
  const [sortOrder, setSortOrder] = useState('desc'); // 'asc' or 'desc'

  const [activeView, setActiveView] = useState('playlists');
  const [playlists, setPlaylists] = useState([]);
  const [songs, setSongs] = useState([]);

  const handleSortChange = (option) => {
    const normalizedOption = option.toLowerCase().replace(' ', ''); // 'Date Added' -> 'dateAdded'

    if (sortBy === normalizedOption) {
      // Toggle sortOrder
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // Change sortBy and default to ascending order
      setSortBy(normalizedOption);
      setSortOrder('asc');
    }

    setShowSortMenu(false);
  };

  const filteredSongs = songs.filter(
    (song) =>
      (activePlaylist.label === 'All Songs' ||
        song.playlistId === activePlaylist.id) &&
      (song.track.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        song.track.artists.some((artist) =>
          artist.name.toLowerCase().includes(searchQuery.toLowerCase())
        ))
  );

  const sortedSongs = [...filteredSongs].sort((a, b) => {
    let comparison = 0;

    switch (sortBy) {
      case 'title':
        comparison = a.track.name.localeCompare(b.track.name);
        break;

      case 'dateAdded':
        // Assuming your song object has a dateAdded field (e.g., ISO string or timestamp)
        comparison = new Date(a.added_at) - new Date(b.added_at);
        break;

      default:
        comparison = 0;
    }

    return sortOrder === 'asc' ? comparison : -comparison;
  });
  // console.error(filteredSongs, sortedSongs, songs, activePlaylist);

  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="navbar-left">
          <h1>Spotify Collab</h1>
          <div className="view-tabs">
            <button
              type="button"
              className={`view-tab ${activeView === 'playlists' ? 'active' : ''}`}
              onClick={() => setActiveView('playlists')}
            >
              <List size={16} /> Playlists
            </button>
            <button
              type="button"
              className={`view-tab ${activeView === 'analytics' ? 'active' : ''}`}
              onClick={() => setActiveView('analytics')}
            >
              <BarChart3 size={16} /> Analytics
            </button>
          </div>
        </div>
        <SpotifyAuth
          onPlaylistsFetched={setPlaylists}
          onSongsFetched={setSongs}
        />
      </nav>

      {activeView === 'analytics' ? (
        <AnalyticsView songs={songs} playlists={playlists} />
      ) : (
      <div className="main-content">
        <aside className="sidebar">
          <h2>Your Playlists</h2>
          {playlists.map((playlist) => (
            <div
              key={playlist.id}
              className={`playlist-card ${
                activePlaylist.label === playlist.name ? 'active' : ''
              }`}
              onClick={() =>
                setActivePlaylist((prevPlaylist) =>
                  prevPlaylist.label === playlist.name
                    ? { label: 'All Songs', id: '' }
                    : { label: playlist.name, id: playlist.id }
                )
              }
            >
              <div className="img-container">
                <img src={playlist.images[0]?.url} alt="Playlist"></img>
              </div>
              <div>
                <div>{playlist.name}</div>
                <small>{playlist.tracks?.total} songs</small>
              </div>
            </div>
          ))}
        </aside>

        <section className="playlist-section">
          <header className="playlist-header">
            <div className="header-content">
              <h2>{activePlaylist.label}</h2>
              <span className="song-count">
                {sortedSongs.length} song{sortedSongs.length !== 1 ? 's' : ''}
              </span>
            </div>
          </header>

          <div className="search-sort-row">
            <div className="search-input">
              <Search size={16} />
              <input
                type="text"
                placeholder="Search songs or artists..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="sort-container">
              <button
                className="btn sort-btn"
                onClick={() => setShowSortMenu(!showSortMenu)}
              >
                <Filter size={16} /> Sort
              </button>

              {showSortMenu && (
                <div className="dropdown-menu">
                  {['Date Added', 'Title'].map((option) => (
                    <div
                      key={option}
                      className="dropdown-item"
                      onClick={() => handleSortChange(option)}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div>
            {sortedSongs.map((song) => (
              <div key={`${song.added_at}`} className="song-card">
                <div className="img-container">
                  {/* <img
                    src={song.track.external_urls.spotify}
                    alt="Playlist"
                  ></img> */}
                </div>
                <div>
                  <div className="song-title">{`${song.track.name} - ${
                    song.track.artists ? song.track.artists[0]?.name : ''
                  }`}</div>
                  <div className="song-data">
                    Added by: {getAddedByLabel(song)} on {song.added_at} to{' '}
                    {song.playlistName}
                  </div>
                  {/* <small>{playlist.tracks.total} songs</small> */}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
      )}
    </div>
  );
};

export default SpotifyCollaborator;
